import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { edit, item as getContractItem, printContract } from '../../../lib/api/contract';
import { ContractForm } from './ContractForm';
import {
  getContractGuid,
  normalizeContractPayload,
  normalizeContractResponse
} from './formUtils';

export function Edit({ initContract, initMode, onClose, onSave }) {
  const { document_guid: routeDocumentGuid } = useParams();
  const [contract, setContract] = useState(normalizeContractResponse(initContract));
  const [isLoading, setIsLoading] = useState(false);

  const createEditPayload = contract => {
    const payload = normalizeContractPayload(contract);
    delete payload.contract_terminations_id;
    delete payload.terminated_at;
    return payload;
  };

  useEffect(() => {
    let isMounted = true;
    const initialContract = normalizeContractResponse(initContract);
    const documentGuid = getContractGuid(initialContract) || routeDocumentGuid;

    if (!documentGuid) {
      setContract(initialContract);
      return () => {
        isMounted = false;
      };
    }

    setIsLoading(true);
    getContractItem(documentGuid)
      .then(response => {
        if (isMounted) {
          setContract(normalizeContractResponse(response) || initialContract);
        }
      })
      .catch(error => {
        console.error(error);
        if (isMounted) {
          setContract(initialContract);
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [initContract, routeDocumentGuid]);

  if (isLoading) {
    return (
      <div className="text-center py-4">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  return (
    <ContractForm
      initialContract={contract}
      mode={initMode || 'edit'}
      onSubmit={async contract => {
        const documentGuid = getContractGuid(contract);
        await edit(createEditPayload(contract), documentGuid);
        await onSave?.();
        onClose?.();
      }}
      onPrint={async (contract, printWindow) => {
        const documentGuid = getContractGuid(contract);
        await edit(createEditPayload(contract), documentGuid);
        await onSave?.();
        await printContract(documentGuid, printWindow);
      }}
    />
  );
}
